import React, { Component } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";
import LoginPage from "views/LoginPage/LoginPage.jsx";
import DocPage from "views/DocPage/DocPage.jsx";
import PDFViewer from "views/PDFViewer/PDFviewer";
import GntChart from "views/GNTChart/GntChart";
import Notice from "views/NoticePage/NoticePage";
import NoticeEdit from "views/NoticePage/NoticeEditPage";
import withStyles from "@material-ui/core/styles/withStyles";
import loginPageStyle from "assets/jss/material-kit-react/views/loginPage.jsx";
import Main from "views/Main.js";
import GlobalValue from "./GlobalValue";

class App extends Component {
  render() {
    const { classes } = this.props;
    return (
      <Router>
        <div className={classes.loginBg}>
          <Route exact path="/" component={Main} />
          <Route exact path="/login" component={LoginPage} />
          <Route exact path="/doc" component={DocPage} />
          <Route exact path="/pdf" component={PDFViewer} />
          <Route exact path="/gnt" component={GntChart} />
          <Route exact path="/notice" component={Notice} />
          <Route exact path="/border" component={NoticeEdit} />
        </div>
      </Router>
    );
  }
}

export default withStyles(loginPageStyle)(App);
